// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { environment as defaultEnvironment } from './environment.defaults';

export const environment = {
  ...defaultEnvironment,
  production: false,
  apiUrl: '/',
  appRegistry: {
    authId: 'Basic vNfGQz17MWHqyy05e6qWaH/zNI1L0IXrDUCQSOaBjub1E+cpOZFi60S9ZuE5e32nR+JQHo/DeGK2Z2pHTJ0DZQakzVZcEGW2vGCDP+OOPODXCpCjHF0ThSw='
  },
  DiagPortal: {
    authId: 'Basic CnfmHtnckpTGvqcP61CMAy3KbSHFU1dVGuqDXVJx5Lxmg+9Eu4khOyswvZtwLTyjQp3qyrd+FZV+T5s7TAL/PCmBcJLkaXQtgwTE6bLMB0i1aGzNHfnr7Lw=',
    url: 'https://newdevportal.hondaconnect.in'
  },
  EiInterface: {
    authId: 'Basic Abvb6Dx/r2Yg3QDUveGlUiGIQzhR4VW/B0xZfgF1sXnAPGd8kmhyGGY5HBBejzswHc5TGyooHxA3WtLV6OthW8QoqXmjjFnXvcdXoL/HpcvofMXDZa/p5XU=',
    url: 'http://10.162.254.200:7187/'
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
